module.exports = __webpack_public_path__ + "media/images/banks/citibank-0b11f3ca2d01d758ff17c2904af55681.png";